import ErrorDetail from './ErrorDetail.jsx'
import ErrorIcon from './ErrorIcon.jsx'
import LoadingAnimation from './LoadingAnimation.jsx'

/**
 * 
 * @param {any} loadedSignals: if any of the signals are false, the content will be replaced with a load animation
 * @param {any} errorSignals: if any of the signals are non-null, the content will be replaced with error message(s)
 * @param {any} content: content to display once all loading is complete
 * @returns
 */
const Loadable = ({ children, loadedSignals, errorSignals = [], detail = false, title = null, debug = false }) => {
    let print = debug
    let errors = []
    for (let i = 0; i < errorSignals.length; i++) {
        if (errorSignals[i].value) {
            errors.push(errorSignals[i].value)
            if (!detail) {
                break
            }
        }
    }
    if (print) {
        console.log(`Inside Loadable with ${loadedSignals.length} loaded signals and ${errorSignals.length} error signals.`)
    }
    if (errors.length > 0) {
        if (print) {
            console.log(`There were ${errors.length} errors`)
        }
        if (detail) {
            if (print) {
                console.log("Returning a detailed error component")
            }
            return (<ErrorDetail errors={errors} />)
        }
        else if (print) {
            console.log("Returning a basic error icon")
        }
        return <ErrorIcon />
    }
    else if (print) {
        console.log("There were no errors")
    }
    for (let i = 0; i < loadedSignals.length; i++) {
        if (!loadedSignals[i].value) {
            if (print) {
                console.log("Returning a loading animation")
            }
            return (<LoadingAnimation title={title ? title : undefined} />)
        }
    }
    if (print) {
        console.log("No errors, all loading flags set. Returning the content.")
    }
    return children
}
export default Loadable